import TableSkeleton from '../Skeletons';

const TableLoading = ({ columns }) => {
  return (
    <TableSkeleton
      showSkeletonColumnsHead
      columns={columns}
      skeletonColumns={columns.map(col => 'singleline-random')}
    />
  );
};

export default TableLoading;
